import type { CaptchaPageData, LandingPageData, LegacyPageData, PublicPageData } from '@/types';

export const getRawData = (): PublicPageData & { legacy?: boolean } => {
	return (window as unknown as { __data: PublicPageData & { legacy?: boolean } })?.__data || defaultMsg('landing-page');
};

export default function useData<T = PublicPageData>() {
	const pageData: PublicPageData = getRawData();

	// Must check for legacy data types
	if ((pageData as unknown as LegacyPageData)?.legacy) {
		const legacy = pageData as unknown as LegacyPageData;
		return {
			uid: legacy.uid,
			account_name: legacy.name,
			page_type: 'landingPage',
			content: {
				banner: legacy.banner,
				is_html: legacy.isHTML,
				media: legacy.media,
				mediaType: legacy.mediaType,
				message_body: legacy.msg,
				square_logo: legacy.squareLogo,
			},
		} as LandingPageData;
	}

	return pageData as T;
}

const defaultMsg = (type?: 'captcha' | 'landing-page') => {
	const isLocalHost = window.location.hostname === 'localhost';
	const isStaging = window.location.hostname === 'lab.aiqstaging.net';
	if (!isLocalHost && !isStaging) {
		return {
			uid: '',
			account_name: '',
		} as PublicPageData;
	}
	if (type === 'captcha') {
		return {
			uid: '1099',
			account_name: 'Cookies',
			page_type: 'captchaPage',
			shorty_key: '1234',
			settings: {
				methods: {
					pin: {
						enabled: false,
						button: {},
						header: {},
					},
					phone: {
						enabled: true,
						button: {},
						header: {},
					},
					dob: {
						enabled: false,
						button: {},
						header: {},
					},
				},
			},
		} as CaptchaPageData;
	}
	return {
		uid: '1099',
		account_name: 'Cookies',
		page_type: 'landingPage',
		store_id: '123',
		store_name: 'Store Nane',
		content: {
			mediaType: 'image/jpeg',
			media: 'https://lab.alpineiq.com/campaign/media/1099/4368',
			message_body: `
        Hi {{firstName}}, This is my text message. I can now talk all I want about the things I want to get across to my customers that are important to them. I no longer need to drop massive 💰 just to talk about cannabis:
        - This is a new item on our menu
        - This is how you can help relieve pain
        - This is your points balance: X
        - https://google.com
        - Our latest stores are opening March 1st and 14th on Berry st. in Downtown Oklahoma and you will likely want to try Jessica's favorite strain Purple Melon which is a craft micro grown etc...
        You can see how you can capture more attention while getting freedom to tell your story.`,
			// banner: 'https://lab.alpineiq.com/campaign/media/1099/4368',
			banner: '',
			is_html: false,
			square_logo: false,
		},
		style: { // Mocking up the style object from Brand Settings / BrandStyle instead of LandingPageSettings.style
			brandColor: "#00a1e0",
			linkColor: "#00a1e0",
			secondaryColor: "#FFFFFF",
			buttonPrimary: {
				borderRadius: {
					topLeft: 100,
					topRight: 100,
					bottomLeft: 100,
					bottomRight: 100,
				},
				bg: "#00a1e0",
				borderColor: "#00a1e0",
				color: "#FFFFFF",
			},
			buttonSecondary: {
				borderRadius: {
					topLeft: 100,
					topRight: 100,
					bottomLeft: 100,
					bottomRight: 100,
				},
				bg: "#FFFFFF",
				borderColor: "#E2E6ED",
				color: "#080808",
			},
			buttonSpecial: {},
		},
		settings: {
			variant: 'linkTree',
			// variant: "modern",
			captchaMethod: 'age-gate',
			// captchaMethod: 'multiple-choice',

			buttonsMap: {
				shopOnline: {
					text: '',
					url: 'https://google.com',
					enabled: true,
				},
				directions: {
					text: '',
					url: 'https://google.com',
					enabled: true,
				},
				callUs: {
					text: '',
					url: 'https://google.com',
					enabled: true,
				},
				memberWallet: {
					text: '',
					url: 'https://google.com',
					enabled: true,
				},
			},
			style: {},
		},
		// skipProviderRestrictions: true,
		// enableMessageInbox: true,
	} as LandingPageData;
};
